<button mat-fab class="floating-button border1px orangeBC corporate-button" (click)="toggleChat()"
  [matBadge]="countMessageNotRead" matBadgePosition="above after" matBadgeColor="warn" matBadgeOverlap="false"
  [matBadgeHidden]="countMessageNotRead === 0">
  💬
</button>
<div class="chat-window card border1px animate__animated" [@chatAnimation] [ngClass]="{
  'animate__fadeInUp': isChatOpen && !animationInProgress,
  'animate__fadeOutDown': !isChatOpen && animationInProgress,
  'hidden': !isChatOpen && !animationInProgress
}" *ngIf="isChatOpen || animationInProgress || messages.length > 0" (animationstart)="onAnimationStart()"
  (animationend)="onAnimationDone()">
  <div class="chat-header card-header d-flex justify-content-between align-items-center"
    style="color: black; border-bottom: 1px solid black">
    <ng-container *ngIf="!hasSelectedParameters(); else backButton">
      <h3 class="mb-0">{{ "CHAT" | translate }}</h3>
    </ng-container>
    <ng-template #backButton>
      <button mat-icon-button (click)="goBackToPendingMessages()">
        <mat-icon [matTooltip]="'GO_BACK' | translate">arrow_back</mat-icon>
      </button>
      <div id="icon-container">
        <h3 class="mb-0">
          <span *ngIf="selectedReference.referenciaCliente">{{ selectedReference.referenciaCliente }} -</span> {{
          selectedReference.codigo }}
          <span
            *ngIf="selectedReference?.destinatario != '' && selectedReference?.destinatario != null && selectedReference?.destinatario != undefined">-
            {{ selectedReference?.destinatario }}</span>
        </h3>

        <mat-icon *ngIf="messages.length > 0" class="download-icon" (click)="downloadChatAsPDF()"
          [matTooltip]="'DOWNLOAD_CHAT' | translate">
          download
        </mat-icon>

        <!-- La bombilla aparece solo si hay mensajes sin leer -->
        <mat-icon *ngIf="countMessageNotReadInd != 0" class="bombilla-icon"
          [ngClass]="{ 'bombilla-blink': !isUserAtBottom }" (click)="scrollToBottom(true)"
          [matTooltip]="'NEW_MESSAGES' | translate">
          lightbulb
        </mat-icon>
      </div>
    </ng-template>
    <button [matTooltip]="isChatOpen ? ('CLOSE_CHAT' | translate) : ('Abrir chat' | translate)" mat-icon-button
      matTooltipPosition="left" [matTooltipDisabled]="false" (click)="toggleChat()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div #chatContent class="chat-content card-body messages-background" (scroll)="onChatScroll()">
    <div *ngIf="!hasSelectedParameters()" class="search-container">
      <mat-form-field appearance="outline" floatLabel="never" class="search-field compact-search">
        <input matInput [placeholder]="'SearchPlaceholder' | translate" [(ngModel)]="searchTerm"
          (input)="filtrarChats()" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <!-- Mostrar tabla de mensajes pendientes si no hay partida, cotización o expedición seleccionada -->
    <ng-container *ngIf="!hasSelectedParameters(); else messageList">
      <ng-container *ngIf="messagesSinLeer.length > 0; else messagesPendientesVacios">
        <div class="pending-messages-container">
          <div class="pending-message-card" *ngFor="let pending of chatsFiltrados; trackBy: trackByMessageId" (click)="selectConversation({
    partida: pending.partida,
    expedicion: pending.expedicion,
    cotizacion: pending.cotizacion,
    referenciaCliente: pending.referenciaCliente,
    destinatario: pending.destinatario
  })" (mouseenter)="applyHoverEffect($event)" (mouseleave)="removeHoverEffect($event)">

            <!-- Barra / Bloque lateral con icono e identificación de tipo -->
            <div class="pending-message-type">
              <span class="message-icon-wrapper" [matTooltip]="'CHAT_TYPE_' + pending.tipo.toUpperCase() | translate">
                <img *ngIf="!pending.iconFallback" class="type-icon"
                  [src]="'../../../../assets/imagenes/' + pending.icono" alt="{{ pending.tipo }}"
                  (error)="onIconError($event, pending)" />
                <mat-icon *ngIf="pending.iconFallback" class="type-icon">chat</mat-icon>
              </span>
            </div>

            <!-- Contenido principal: referencia, identificador, hora y preview -->
            <div class="pending-message-content">
              <div class="pending-message-header">
                <div class="pending-message-titles">
                  <!-- Referencia y ID -->
                  <span class="reference" *ngIf="pending.referenciaCliente">
                    {{ pending.referenciaCliente }} -
                  </span>
                  <span class="identificador">
                    {{ pending.partida || pending.cotizacion || pending.expedicion }}
                  </span>
                  <span class="reference"
                    *ngIf="pending.destinatario != '' && pending.destinatario != null && pending.destinatario != undefined">-
                    {{ pending.destinatario }}</span>
                </div>
              </div>
              <div class="pending-message-preview">
                {{ pending.prefijo | translate }}:
                <span *ngIf="pending.esArchivo" class="file-icon-inline">
                  <mat-icon>attach_file</mat-icon>
                </span>
                {{ getMessage(pending.esArchivo, pending.ultimoMensaje) || ('NO_DESCRIPTION' | translate) }}
              </div>

            </div>

            <!-- Badge y flecha si hay mensajes pendientes -->
            <div class="badge-section">
              <!-- Fila con badge (cantidad) y flecha -->
              <div class="message-info badge-arrow-row">
                <!-- Cantidad (si la hay) -->
                <div *ngIf="pending.cantidad > 0" class="message-badge orangeBC">
                  {{ pending.cantidad }}
                </div>
                <!-- Flecha -->
                <mat-icon class="arrow-icon">chevron_right</mat-icon>
              </div>
              <!-- Fecha debajo -->
              <div class="date-text">
                {{ pending.horaUltimoMensaje }}
              </div>
            </div>

          </div>
        </div>

      </ng-container>
      <ng-template #messagesPendientesVacios>
        <div class="d-flex flex-column justify-content-center align-items-center mt11em">
          <mat-icon class="congrats-icon" aria-hidden="true">emoji_events</mat-icon>
          <h2 class="congrats-title">{{ 'CONGRATS' | translate }}</h2>
          <p class="congrats-text">
            {{ 'NO_PENDING_MESSAGES' | translate }}
          </p>
        </div>
      </ng-template>
    </ng-container>
    <!-- Mostrar mensajes normales si hay una conversación seleccionada -->
    <ng-template #messageList>
      <!-- No hay mensajes en la conversación -->
      <div class="no-messages-container" *ngIf="messages.length === 0">
        <div class="no-messages">
          <mat-icon class="no-messages-icon" aria-hidden="true">forum</mat-icon>
          <h2>{{ 'NO_MESSAGES_YET' | translate }}</h2>
          <p>{{ 'BREAK_THE_ICE' | translate }}</p>
        </div>
      </div>
      <!-- Hay mensajes en la conversación -->
      <div *ngFor="let message of messages; trackBy: trackByMessageId"
        [ngClass]="{ 'message message-container user-message': isUserMessage(message), 'message message-container other-message': !isUserMessage(message) }">
        <div class="message-header d-flex justify-content-between align-items-center">
          <ng-container *ngIf="isUserMessage(message); else receivedHeader">
            <!-- Mensaje enviado: nombre a la izquierda y, a la derecha, primero la papelera y luego la fecha -->
            <div class="header-left">
              <p class="message-usuario"><strong>{{ message.usuario }}</strong></p>
              <small class="delete-button" *ngIf="canDeleteMessage(message)" (click)="deleteMessage(message)"
                [matTooltip]="'DELETE_CHAT' | translate">
                <mat-icon class="delete-button-mat-icon">delete</mat-icon>
              </small>
            </div>
            <div class="header-right d-flex align-items-center">
              <small class="message-fecha">{{ message.fecha }}</small>
            </div>
          </ng-container>
          <ng-template #receivedHeader>
            <!-- Mensaje recibido: fecha a la izquierda y nombre a la derecha -->
            <div class="header-left">
              <small class="message-fecha">{{ message.fecha }}</small>
            </div>
            <div class="header-right">
              <p class="message-usuario"><strong>{{ message.usuario }}</strong></p>
            </div>
          </ng-template>
        </div>

        <div class="message-text-container">
          <ng-container *ngIf="message.esArchivo; else textMessage">
            <a href="javascript:void(0)" class="file-message" (click)="onFileClick(message.codigo)"
              [matTooltip]="'DOWNLOAD_FILE' | translate">
              <mat-icon id="file">attach_file</mat-icon>
              <span class="file-name">{{ getMessage(message.esArchivo, message.mensaje) }}</span>
            </a>
          </ng-container>
          <ng-template #textMessage>
            <p class="message-text mb-0 mr-2">{{ getMessage(message.esArchivo, message.mensaje) }}</p>
          </ng-template>

          <!-- Doble check (solo para mensajes enviados) -->
          <span *ngIf="isUserMessage(message)" class="message-status" [ngClass]="{
        'double-check-read': message.leido === true,
        'double-check-unread': message.leido == null || message.leido === false
      }" style="letter-spacing: -5px">
            ✔✔
          </span>
        </div>
      </div>

    </ng-template>
  </div>

  <!-- Ícono de flecha hacia abajo -->
  <!-- Solo si NO está abajo del todo -->
  <!-- Al hacer clic, baja hasta el final -->
  <mat-icon *ngIf="!isUserAtBottom && hasSelectedParameters()" class="scroll-down-icon" (click)="scrollToBottom(true)"
    [matTooltip]="'SCROLL_TO_BOTTOM' | translate">
    arrow_downward
  </mat-icon>
  <div class="drag-drop-container" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <!-- Mostrar mensaje cuando se arrastra un archivo -->
    <div *ngIf="isDragOver" class="drag-drop-message">
      {{ 'DROP_FILE_HERE' | translate }}
    </div>
    <form #messageForm="ngForm" (ngSubmit)="sendMessage()" class="chat-input card-footer d-flex"
      *ngIf="hasSelectedParameters()" style="border-top: 1px solid black" novalidate>
      <div class="input-container">
        <!-- Mostrar input de texto si no hay archivo, y un select si hay archivo -->
        <ng-container *ngIf="uploadedFiles.length === 0; else fileTypeSelect">
          <input #messageInput type="text" class="form-control flex-grow-1 h100"
            [placeholder]="'WRITE_MESSAGE_OR_DRAG_FILE' | translate" name="message" ngModel required />
          <div *ngIf="messageForm.submitted && messageInput.errors?.required" class="text-danger mt-1">
            {{ 'EMPTY_MESSAGE_ERROR' | translate }}
          </div>
        </ng-container>

        <ng-template #fileTypeSelect>
          <div class="flex-grow-1">
            <div *ngIf="uploadedFiles.length > 0" class="uploaded-files-preview">
              <div *ngFor="let item of uploadedFiles; let i = index" class="uploaded-file-row">
                <div class="file-name">
                  {{ item.file.name }}
                </div>

                <select class="form-control" [(ngModel)]="item.tipoArchivo" [name]="'fileType' + i" required>
                  <option [ngValue]="-1" disabled>{{ 'SELECT_FILE_TYPE' | translate }}</option>
                  <option *ngFor="let tipo of listaTipoArchivos" [ngValue]="tipo.IdTipoArchivo">
                    {{ tipo.NombreTipoArchivo | translate }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </ng-template>

        <!-- Iconos de acción -->
        <mat-icon class="upload-icon" [ngClass]="{ 'upload-icon--no-file': uploadedFiles.length === 0 }"
          (click)="onUploadIconClick()"
          [matTooltip]="uploadedFiles.length > 0 ? ('EDIT_FILE' | translate) : ('UPLOAD_FILE' | translate)">
          {{ uploadedFiles.length > 0 ? "edit" : "attach_file" }}
        </mat-icon>

        <mat-icon *ngIf="uploadedFiles.length > 0" class="cancel-upload-icon" [matTooltip]="'CANCEL_UPLOAD' | translate"
          (click)="cancelUpload($event)">
          cancel
        </mat-icon>

        <input #fileInput type="file" class="file-input" (change)="onFileSelected($event)" hidden multiple />
      </div>

      <button mat-raised-button id="buttonEnviarChat" class="orangeBC h100" type="submit" [disabled]="submit"
        [matTooltip]="'SEND_MESSAGE' | translate">
        {{ 'SEND' | translate }}
      </button>
    </form>
  </div>
</div>